module.exports = __webpack_public_path__ + "img/collapse.3956ab9c.svg";